import type { ComponentPropsWithRef } from 'react'
import styles from './TableScroller.module.css'

type TableScrollerProps = Omit<ComponentPropsWithRef<'div'>, 'className'>

/**
 * Table scroller. Put the <Table> inside of this.
 */
export function TableScroller({ children, ref, ...rest }: TableScrollerProps) {
  return (
    <div ref={ref} className={styles.root} {...rest}>
      {children}
    </div>
  )
}
